import '../assets/NcActionInput-8F2WF3yH.css';
import l from "../Components/NcDateTimePicker.mjs";
import n from "../Components/NcDateTimePickerNative.mjs";
import { N as r } from "./NcPasswordField-BgSp7dK4.mjs";
import { N as o } from "./NcSelect-Bo71Yd6L.mjs";
import { N as c } from "./NcTextField-D_eUEl2B.mjs";
import { A as u } from "./actionGlobal-D49NL940.mjs";
import { G as s } from "./GenRandomId-BW3iYFf9.mjs";
import { r as d, f as p, a as b } from "./_l10n-BaNxGGXy.mjs";
import { n as m } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
d(p);
const f = {
  name: "NcActionInput",
  components: {
    NcDateTimePicker: l,
    NcDateTimePickerNative: n,
    NcPasswordField: r,
    NcSelect: o,
    NcTextField: c
  },
  mixins: [u],
  props: {
    /**
     * id attribute of the checkbox element
     */
    id: {
      type: String,
      default: () => "action-" + s(),
      validator: (e) => e.trim() !== ""
    },
    /**
     * id attribute of the text input element
     */
    inputId: {
      type: String,
      default: () => "action-input-" + s(),
      validator: (e) => e.trim() !== ""
    },
    /**
     * Icon to show with the action, can be either a CSS class or an URL
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * type attribute of the input field
     */
    type: {
      type: String,
      default: "text",
      validator(e) {
        return [
          "date",
          "datetime-local",
          "month",
          "multiselect",
          "number",
          "password",
          "search",
          "tel",
          "text",
          "time",
          "url",
          "week",
          "color",
          "email"
        ].indexOf(e) > -1;
      }
    },
    /**
     * id attribute for the native date time picker
     */
    idNativeDateTimePicker: {
      type: String,
      default: "date-time-picker_id"
    },
    /**
     * Flag to use a native date time picker
     */
    isNativePicker: {
      type: Boolean,
      default: !1
    },
    /**
     * The visible input label for accessibility purposes.
     */
    label: {
      type: String,
      default: null
    },
    /**
     * If you want to show the label just above the
     * input field, pass in `true` to this prop.
     */
    labelOutside: {
      type: Boolean,
      default: !0
    },
    /**
     * value attribute of the input field
     */
    value: {
      type: [String, Date, Number, Array],
      default: ""
    },
    /**
     * disabled state of the input field
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * aria-label attribute of the input field
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * @deprecated To be removed in @nextcloud/vue 9. Migration guide: remove ariaHidden prop from NcAction* components.
     * @todo Add a check in @nextcloud/vue 9 that this prop is not provided,
     * otherwise root element will inherit incorrect aria-hidden.
     */
    ariaHidden: {
      type: Boolean,
      default: null
    },
    /**
     * Attribute forwarded to the underlying NcPasswordField and NcTextField
     */
    showTrailingButton: {
      type: Boolean,
      default: !0
    },
    /**
     * Trailing button label forwarded to the underlying NcTextField
     */
    trailingButtonLabel: {
      type: String,
      default: b("Submit")
    }
  },
  emits: [
    "input",
    "submit",
    "change",
    "update:value"
  ],
  computed: {
    isIconUrl() {
      try {
        return new URL(this.icon);
      } catch {
        return !1;
      }
    },
    isMultiselectType() {
      return this.type === "multiselect";
    },
    nativeDatePickerType() {
      switch (this.type) {
        case "date":
        case "month":
        case "time":
        case "week":
        case "datetime-local":
          return this.type;
      }
      return !1;
    },
    datePickerType() {
      if (!this.isNativePicker)
        switch (this.type) {
          case "date":
          case "month":
          case "time":
            return this.type;
          case "datetime-local":
            return "datetime";
        }
      return !1;
    },
    /**
     * determines if the action is focusable
     *
     * @return {boolean} is the action focusable ?
     */
    isFocusable() {
      return !this.disabled;
    }
  },
  methods: {
    // closing datepicker popup on mouseleave = unfocus
    onLeave() {
      this.$refs.datetimepicker && this.$refs.datetimepicker.$refs.datepicker && this.$refs.datetimepicker.$refs.datepicker.closePopup();
    },
    onInput(e) {
      this.$emit("input", e), this.$emit("update:value", e.target ? e.target.value : e);
    },
    onSubmit(e) {
      if (e.preventDefault(), e.stopPropagation(), !this.disabled)
        this.$emit("submit", e);
      else
        return !1;
    },
    onChange(e) {
      this.$emit("change", e);
    }
  }
};
var _ = function() {
  var t = this, a = t._self._c;
  return a("li", { staticClass: "action", class: { "action--disabled": t.disabled } }, [a("span", { staticClass: "action-input", class: {
    "action-input-picker--disabled": t.disabled,
    "action-input--visible-label": t.labelOutside && t.label
  }, on: { mouseleave: t.onLeave } }, [a("span", { staticClass: "action-input__icon-wrapper" }, [t._t("icon", function() {
    return [a("span", { staticClass: "action-input__icon", class: [t.isIconUrl ? "action-input__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? "url(".concat(t.icon, ")") : null }, attrs: { "aria-hidden": "true" } })];
  })], 2), a("form", { ref: "form", staticClass: "action-input__form", attrs: { disabled: t.disabled }, on: { submit: function(i) {
    return i.preventDefault(), t.onSubmit.apply(null, arguments);
  } } }, [a("div", { staticClass: "action-input__container" }, [t.label && t.labelOutside ? a("label", { staticClass: "action-input__text-label", class: { "action-input__text-label--hidden": !t.labelOutside }, attrs: { for: t.inputId } }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), a("div", { staticClass: "action-input__input-container" }, [t.datePickerType ? a("NcDateTimePicker", t._b({ ref: "datetimepicker", staticClass: "action-input__datetimepicker", staticStyle: { "z-index": "99999999999" }, attrs: { value: t.value, placeholder: t.text, disabled: t.disabled, type: t.datePickerType, "input-class": ["mx-input", { focusable: t.isFocusable }] }, on: { input: t.onInput, change: t.onChange } }, "NcDateTimePicker", t.$attrs, !1)) : t.isNativePicker ? a("NcDateTimePickerNative", t._b({ staticClass: "action-input__datetimepicker", attrs: { id: t.idNativeDateTimePicker, value: t.value, type: t.nativeDatePickerType, "input-class": { focusable: t.isFocusable } }, on: { input: function(i) {
    return t.$emit("input", i);
  }, change: function(i) {
    return t.$emit("change", i);
  } } }, "NcDateTimePickerNative", t.$attrs, !1)) : t.isMultiselectType ? a("NcSelect", t._g(t._b({ staticClass: "action-input__multi", attrs: { value: t.value, placeholder: t.text, disabled: t.disabled, "append-to-body": t.$attrs.appendToBody || t.$attrs["append-to-body"] || !1, "input-class": { focusable: t.isFocusable } } }, "NcSelect", t.$attrs, !1), t.$listeners)) : t.type === "password" ? a("NcPasswordField", t._g(t._b({ attrs: { id: t.inputId, value: t.value, label: t.label, "label-outside": !t.label || t.labelOutside, placeholder: t.text, disabled: t.disabled, "input-class": { focusable: t.isFocusable }, "show-trailing-button": t.showTrailingButton && !t.disabled }, on: { input: t.onInput, change: t.onChange } }, "NcPasswordField", t.$attrs, !1), t.$listeners)) : t.type === "color" ? a("div", { staticClass: "action-input__container" }, [t.label && t.type === "color" ? a("label", { staticClass: "action-input__text-label", class: { "action-input__text-label--hidden": !t.labelOutside }, attrs: { for: t.inputId } }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), a("div", { staticClass: "action-input__input-container" }, [a("NcColorPicker", t._g(t._b({ staticClass: "colorpicker__trigger", attrs: { id: "inputId", value: t.value }, on: { input: t.onInput, submit: function(i) {
    return t.$refs.form.requestSubmit();
  } } }, "NcColorPicker", t.$attrs, !1), t.$listeners), [a("button", { staticClass: "colorpicker__preview", class: { focusable: t.isFocusable }, style: { "background-color": t.value } })])], 1)]) : a("NcTextField", t._g(t._b({ attrs: { id: t.inputId, value: t.value, label: t.label, "label-outside": !t.label || t.labelOutside, placeholder: t.text, disabled: t.disabled, "input-class": { focusable: t.isFocusable }, type: t.type, "trailing-button-icon": "arrowRight", "trailing-button-label": t.trailingButtonLabel, "show-trailing-button": t.showTrailingButton && !t.disabled }, on: { "trailing-button-click": function(i) {
    return t.$refs.form.requestSubmit();
  }, input: t.onInput, change: t.onChange } }, "NcTextField", t.$attrs, !1), t.$listeners))], 1)])])])]);
}, h = [], g = /* @__PURE__ */ m(
  f,
  _,
  h,
  !1,
  null,
  "3706febe",
  null,
  null
);
const w = g.exports;
export {
  w as N
};
